export default {
  'menu.ad-callback.x-callback': 'X API',
  'menu.overseas.media-buyer': 'Media buyer services',
  'menu.ad-callback.trafficstars-callback': 'TrafficStars S2S',
  'menu.system.access-logs': 'System Verification Logs',
  'menu.welcome': 'Welcome',
  'menu.staff-accounts': 'Staff Accounts',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.changePassword': 'Change Password',
  'menu.purchaseHistory': 'Purchase History',
  'menu.domainRental': 'Domain Rental',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.system': 'System Management',
  'menu.system.order-management': 'Order Management',
  'menu.system.user-management': 'User Management',
  'menu.system.doc-category-management': 'Document Categories',
  'menu.system.doc-management': 'Document Management',
  'menu.system.doc-create': 'Create Document',
  'menu.system.doc-edit': 'Edit Document',
  'menu.system.site-config': 'Site Configuration',
  'menu.system.params-config': 'Parameters Configuration',
  'menu.system.domain-config': 'Domain Configuration',
  'menu.system.baota-config': 'BaoTa Configuration',
  'menu.system.nginx-ip-block': 'WhatsApp IP Blocking',
  'menu.system.email-template': 'Email Template',
  'menu.system.rental-domain-management': 'Rental Domain Management',
  'menu.system.cloak-blacklist-management': 'Cloak IP Management',
  'menu.cloak-whitelist-management': 'Cloak Whitelist',
  'menu.system.cloak-whitelist-management': 'Cloak Whitelist',
  'menu.system.membership-plans': 'Membership Plans',
  'menu.system.template-library-management': 'Template Library Management',
  'menu.system.wallet-config': 'Wallet Configuration',
  'menu.system.recharge-records': 'Recharge Records',
  'menu.system.agent-management': 'Agent Management',
  'menu.system.landing-page-management': 'Landing Page Management',
  'menu.system.public-review-page-management': 'Public Review Pages',
  'menu.overseas': 'Overseas Distribution',
  'menu.overseas.kakao-list': 'KaKaoTalk',
  'menu.overseas.whatsapp-list': 'WhatsApp',
  'menu.overseas.whatsapp-stats': 'WhatsApp Statistics',
  'menu.overseas.line-list': 'Line',
  'menu.overseas.facebook-diversion': 'Facebook',
  'menu.overseas.tg-list': 'Telegram',
  'menu.overseas.sms-list': 'SMS',
  'menu.overseas.custom-diversion': 'Custom Diversion',
  'menu.overseas.service-management': 'Service Management',
  'menu.overseas.work-order': 'Work Order Management',
  'menu.customer-diversion': 'In Development',
  'menu.customer-diversion.whatsapp': 'WhatsApp',
  'menu.customer-diversion.line': 'Line',
  'menu.customer-diversion.facebook': 'Facebook',
  'menu.customer-diversion.custom': 'Custom',
  'menu.customer-diversion.tg': 'Telegram',
  'menu.customer-diversion.service-management': 'Service Management',
  'menu.customer-diversion.media-buyer': 'Media buyer services',
  'menu.ad-callback': 'Ad Callback',
  'menu.ad-callback.tiktok-callback': 'TikTok API',
  'menu.ad-callback.tiktok-create': 'Create Config',
  'menu.ad-callback.tiktok-edit': 'Edit Config',
  'menu.ad-callback.tiktok-stats': 'Statistics',
  'menu.ad-callback.facebook-callback': 'Facebook API',
  'menu.ad-callback.facebook-create': 'Create Config',
  'menu.ad-callback.facebook-edit': 'Edit Config',
  'menu.ad-callback.facebook-stats': 'Statistics',
  'menu.ad-callback.manual-ad-callback': 'Manual Callback',
  'menu.ad-callback.manual-ad-callback-create': 'Create Manual Callback',
  'menu.ad-callback.pinterest-callback': 'Pinterest API',
  'menu.ad-callback.pinterest-create': 'Create Config',
  'menu.ad-callback.pinterest-edit': 'Edit Config',
  'menu.ad-callback.pinterest-stats': 'Statistics',
  'menu.ad-callback.bigo-callback': 'BigO API',
  'menu.ad-callback.bigo-create': 'Create Config',
  'menu.ad-callback.bigo-edit': 'Edit Config',
  'menu.ad-callback.bigo-stats': 'Statistics',
  'menu.ad-callback.google-callback': 'Google',
  'menu.ad-callback.google-create': 'Create Config',
  'menu.ad-callback.google-edit': 'Edit Config',
  'menu.ad-callback.google-stats': 'Statistics',
  'menu.landing-page': 'Landing Page',
  'menu.landing-page.page-list': 'Landing Page List',
  'menu.landing-page.ai-landing-page': 'AI Landing Pages',
  'menu.landing-page.ai-landing-page-list': 'AI Landing Page List',
  'menu.landing-page.ai-landing-page-create': 'Create AI Landing Page',
  'menu.landing-page.ai-landing-page-edit': 'Edit AI Landing Page',
  'menu.landing-page.form-management': 'Form Management',
  'menu.landing-page.ad-callback-selection': 'Ad Callback',
  'menu.landing-page.ad-callback-selection-ios': 'Local Ad Callback',
  'menu.landing-page.page-stats': 'Page Statistics',
  'menu.landing-page.template-library': 'Template Library',
  'menu.landing-page.page-create': 'Create Landing Page',
  'menu.landing-page.page-edit': 'Edit Landing Page',
  'menu.cloak': 'Cloak Management',
  'menu.chat-management': 'Chat Management',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.ad-callback.superh-callback': 'Super Callback',
  'menu.ad-callback.superh-create': 'Create Super Callback',
  'menu.ad-callback.superh-edit': 'Edit Super Callback',
  'menu.ad-callback.deep-callback': 'Deep Callback',
  'menu.ad-callback.external-callback': 'External Callback',
  'menu.ad-callback.external-create': 'Create External Callback',
  'menu.ad-callback.external-edit': 'Edit External Callback',
  'menu.ad-callback.external-stats': 'External Callback Statistics',
  'menu.membership': 'Membership Center',
  'menu.membership.membership-buy': 'Membership Purchase',
  'menu.pricing': 'Pricing',
  'menu.docs': 'Documentation',
  'menu.doc-detail': 'Document Detail',
  'menu.bbs': 'Forum',
  'menu.user-domain': 'My Domains',
  'menu.myShares': 'Share Management',
  'menu.myAgent': 'My Referral',
  'menu.shareView': 'View Share',
};
